//Modules
import React from "react"
//Styles
import styled from "styled-components"
import { spacing } from "../../Utilities"
//Components
import AccordionSection from "./AccordionSection"

const Accordion = ({ qualifications }) => {
  return (
    <StyledAccordionContainer>
      {qualifications.map((qualification, i) => {
        return <AccordionSection qualification={qualification.node} key={i} />
      })}
    </StyledAccordionContainer>
  )
}

const StyledAccordionContainer = styled.div`
  width: 100%;
  max-width: 768px;
  padding: 0 ${spacing.M};
  margin-bottom: ${spacing.M};
`

export default Accordion
